import { useState } from 'react';

export interface AssignConfirmationState {
  isConfirmationOpen: boolean;
  hasReviewedList: boolean;
  onOpenConfirmation: () => void;
  onCancelConfirmation: () => void;
  onListReviewedToEnd: () => void;
}

export const useAssignConfirmationState = (): AssignConfirmationState => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [hasReviewedList, setHasReviewedList] = useState(false);

  const onOpenConfirmation = (): void => {
    setIsConfirmationOpen(true);
  };

  const onCancelConfirmation = (): void => {
    setIsConfirmationOpen(false);
    setHasReviewedList(false);
  };

  const onListReviewedToEnd = (): void => {
    setHasReviewedList(true);
  };

  return {
    isConfirmationOpen,
    hasReviewedList,
    onOpenConfirmation,
    onCancelConfirmation,
    onListReviewedToEnd,
  };
};